import { arrayPush, arrayInsert } from "redux-form";
import { syncDirtyBudgets } from "containers/Budget/_actions";
import ReactGA from "react-ga4";

const actionTypes = {
    DISTRIBUTIONS_SAVE: "DISTRIBUTIONS_SAVE",
    ENTERPRISE_SAVE: "ENTERPRISE_SAVE",
    ENTERPRISE_DELETE: "ENTERPRISE_DELETE",
};
export default actionTypes;

export const saveEnterprise = (farmId, budgetId, enterprise) => (dispatch) => {
    ReactGA.event({
        category: "Enterprise",
        action: "Save",
    });
    dispatch({ type: actionTypes.ENTERPRISE_SAVE, payload: { farmId, budgetId, enterprise } });
    dispatch(syncDirtyBudgets(budgetId));
};

export const saveDistributions = (farmId, budgetId, animalDistribution) => (dispatch) => {
    ReactGA.event({
        category: "Enterprise",
        action: "Save Distributions",
    });
    dispatch({ type: actionTypes.DISTRIBUTIONS_SAVE, payload: { farmId, budgetId, animalDistribution } });
    dispatch(syncDirtyBudgets(budgetId));
};

export const deleteEnterprise = (farmId, budgetId, id) => (dispatch) => {
    ReactGA.event({
        category: "Enterprise",
        action: "Delete",
    });
    dispatch({ type: actionTypes.ENTERPRISE_DELETE, payload: { farmId, budgetId, id } });
    dispatch(syncDirtyBudgets(budgetId));
};

export const addLivestockEvent = (evt, insertAt) => (dispatch) => {
    if (insertAt >= 0) dispatch(arrayInsert("modal-form", "events", insertAt, { eventDate: evt.eventDate, eventType: evt.eventType, weightType: evt.weightType, weightMethod: evt.weightMethod }));
    else dispatch(arrayPush("modal-form", "events", { eventDate: evt.eventDate, eventType: evt.eventType, weightType: evt.weightType, weightMethod: evt.weightMethod }));
};
